/* Type guard to check if the error is of type InvalidUserError.
 *
 * @param errorObject - Returns if error is Invalid User error or not
 */
export interface InvalidUserError {
  error: {
    error: string;
  };
}

/**
 * Type guard to check if the error is of type InvalidUserError.
 *
 * @param errorObject - Returns if error is Invalid User error or not
 */
export function isInvalidUserError(errorObject: unknown): errorObject is InvalidUserError {
  return (
    errorObject !== null &&
    typeof errorObject === 'object' &&
    'error' in errorObject &&
    errorObject.error !== null &&
    typeof errorObject.error === 'object' &&
    'error' in errorObject.error &&
    typeof errorObject.error.error === 'string' &&
    errorObject.error.error.trim().length > 0
  );
}
